import {UserModel} from './user.model';

let psd: string;

export class CustomerModel extends UserModel {
  constructor(data: any) {
    super();
    this.country = data.country;
    this.created = data.created;
    this.currency = data.currency;
    if (data.devices) this.devices = data.devices;
    this.displayName = data.displayName;
    this.email = data.email;
    if (data.firstOrder) this.firstOrder = data.firstOrder;
    this.language = data.language;
    this.phone = data.phone;
    if (data.referredBy) this.referredBy = data.referredBy;
    this.role = data.role;
    this.status = data.status;
    this.stpID = data.stpID;
    if (data.uid) this.uid = data.uid;
    if (data.promoCode) this.promoCode = data.promoCode;
    if (data.orders) this.orders = data.orders;
    if (data.pictureURL) this.pictureURL = data.pictureURL;
    psd = data.password;
    this.giveaway = data.giveaway;
  }

  country: string;
  created: number;
  currency: string;
  devices?: Object;
  firstOrder?: string;
  orders?: Array<string>;
  language: string;
  promoCode?: string;
  phone: string;
  pictureURL?: string;
  referredBy: { name: string; id?: string };
  status: boolean;
  stpID: string;
  giveaway: boolean;

  passwordCheck(hash: string | Int32Array) {
    return hash == psd;
  }
}
